import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "busy-indicator-container"
}
const _hoisted_2 = { class: "row" }

import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

import BusyIndicator from '@/components/common/BusyIndicator.vue'
import CardContainer from '@/components/common/CardContainer.vue'
import NotificationBanner from '@/components/common/NotificationBanner.vue'
import LeagueMatchTeamTable from '@/components/widgets/public/LeagueMatchTeamTable.vue'
import LeagueRundownTable from '@/components/widgets/public/LeagueRundownTable.vue'
import { useLeaguesStore } from '@/store/public/leagues'
import { getErrorMessage } from '@/utils/error-handling'


export default /*@__PURE__*/_defineComponent({
  __name: 'LeagueMatchStandingsView',
  setup(__props) {

const leagues = useLeaguesStore()
const route = useRoute()

const errorMessage = ref<string | null>(null)
const isLoading = ref<boolean>(false)

onMounted(async () => {
  errorMessage.value = null
  isLoading.value = true

  try {
    await leagues.selectRoundById(route.params.round as string)
    await leagues.selectMatchById(route.params.match as string)
    await leagues.fetchLeagueMatchStandings()
  } catch (e) {
    const message = getErrorMessage(e as Error)
    console.error(`Failed fetching league standings: ${message}`)
    errorMessage.value = message
  }

  isLoading.value = false
})

return (_ctx: any,_cache: any) => {
  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("h1", _hoisted_1, [
        _createVNode(BusyIndicator)
      ]))
    : (errorMessage.value)
      ? (_openBlock(), _createBlock(NotificationBanner, {
          key: 1,
          message: errorMessage.value,
          "is-danger": ""
        }, null, 8, ["message"]))
      : (_openBlock(), _createBlock(CardContainer, { key: 2 }, {
          default: _withCtx(() => [
            (!_unref(leagues).selectedMatch?.standings)
              ? (_openBlock(), _createBlock(NotificationBanner, {
                  key: 0,
                  message: _ctx.$t('leagues.errors.no-match-results'),
                  "is-warning": ""
                }, null, 8, ["message"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_2, [
                    (_unref(leagues).selectedMatch?.standings?.home_team)
                      ? (_openBlock(), _createBlock(LeagueMatchTeamTable, {
                          key: 0,
                          class: "column",
                          team: _unref(leagues).selectedMatch?.standings?.home_team
                        }, null, 8, ["team"]))
                      : _createCommentVNode("", true),
                    (_unref(leagues).selectedMatch?.standings?.away_team)
                      ? (_openBlock(), _createBlock(LeagueMatchTeamTable, {
                          key: 1,
                          class: "column",
                          team: _unref(leagues).selectedMatch?.standings?.away_team
                        }, null, 8, ["team"]))
                      : _createCommentVNode("", true)
                  ]),
                  ((_unref(leagues).selectedMatch?.standings?.rundown ?? []).length > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("h4", null, _toDisplayString(_ctx.$t('leagues.labels.rundown')), 1),
                        _createVNode(LeagueRundownTable, {
                          rows: _unref(leagues).selectedMatch?.standings?.rundown
                        }, null, 8, ["rows"])
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
          ]),
          _: 1
        }))
}
}

})